import { Menu } from '@mantine/core'
import { ChevronDown } from 'lucide-react'

import StyledBadge from 'src/components/DataDisplay/StyledBadge/StyledBadge'
import StyledMenu from 'src/components/Overlays/StyledMenu/StyledMenu'
import { VoEStatus } from 'src/graphql/types/verificationOfEmployments'
import { formatSnakeValue } from 'src/lib/formatters'

export const colorByStatus: Record<
  string,
  'gray' | 'blue' | 'green' | 'orange' | 'red'
> = {
  NOT_STARTED: 'gray',
  REQUESTED: 'blue',
  PENDING_REVIEW: 'orange',
  COMPLETED: 'green',
  IN_PROGRESS: 'blue',
  CANCELED: 'red',
}

export const VOE_STATUSES = [
  VoEStatus.NOT_STARTED,
  VoEStatus.IN_PROGRESS,
  VoEStatus.PENDING_REVIEW,
  VoEStatus.COMPLETED,
  VoEStatus.CANCELED,
  VoEStatus.DECLINED,
]

interface VoEStatusMenuProps {
  status: VoEStatus | string
  disabled?: boolean
  onSelect: (status: VoEStatus) => void
}

const VoEStatusMenu = ({
  status,
  disabled = false,
  onSelect,
}: VoEStatusMenuProps) => (
  <StyledMenu position="bottom-end">
    <Menu.Target>
      <div
        className="inline-flex"
        role="presentation"
        onClick={(e) => e.stopPropagation()}
      >
        <StyledBadge
          clickable
          textTransform="capitalize"
          color={colorByStatus[status]}
          rightSection={<ChevronDown size={12} />}
        >
          {formatSnakeValue(status)}
        </StyledBadge>
      </div>
    </Menu.Target>
    <Menu.Dropdown className="w-40" onClick={(e) => e.stopPropagation()}>
      {VOE_STATUSES.map((option) => (
        <Menu.Item
          key={option}
          className="text-xs"
          disabled={disabled || option === status}
          onClick={() => onSelect(option)}
        >
          {formatSnakeValue(option)}
        </Menu.Item>
      ))}
    </Menu.Dropdown>
  </StyledMenu>
)

export default VoEStatusMenu
